import React, { ReactNode } from 'react';
import { HelpTooltip } from 'src/modules/automations/components/atoms/help-tooltip';

interface WithTooltipProps {
  children: ReactNode;
  tooltip?: string;
  align?: 'center' | 'start';
  containerClassName?: string;
  className?: string;
}

export const WithTooltip: React.FC<WithTooltipProps> = ({
  children,
  tooltip,
  align = 'center',
  containerClassName = '',
  className = '',
}) => {
  return (
    <div className={`flex items-${align} gap-2 ${containerClassName}`}>
      <div className={`flex-grow ${className}`}>{children}</div>
      {tooltip && <HelpTooltip content={tooltip} />}
    </div>
  );
};
